import { useState, useEffect } from 'react';
import { ZIPCODE_NOT_FOUND_ERROR_CODE } from '../constants/error-codes';
import { pushErrorEvent } from '../utils/analytics';
import { capitalizeCityState } from '../utils/zip-code';
import { formatCityState } from '../components/shared/city-state-select/city-state-select';
import { addressesApi } from '../api/common/addresses';
import { ZIPCODE_REGEX } from '../constants/regex';
export var useZipCode = function (zipcode, defaultCityState) {
    var normalizeCityState = capitalizeCityState(defaultCityState || '');
    var defaultCities = normalizeCityState
        ? [
            {
                city: normalizeCityState.split(',')[0].trim(),
                state: normalizeCityState.split(',')[1].trim(),
            },
        ]
        : null;
    var _a = useState(!!zipcode), isInitialZipCode = _a[0], setIsInitialZipCode = _a[1];
    var _b = useState(false), isZipCodePending = _b[0], setZipCodePending = _b[1];
    var _c = useState(defaultCities), cities = _c[0], setCities = _c[1];
    var _d = useState(normalizeCityState), cityState = _d[0], setCityState = _d[1];
    var _e = useState(false), zipCodeApiError = _e[0], setZipCodeApiError = _e[1];
    var _f = useState(false), zipCodeNotFoundError = _f[0], setZipCodeNotFoundError = _f[1];
    useEffect(function () {
        loadCities(zipcode || '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var resetCities = function () {
        setCities(null);
        setCityState('');
    };
    var loadCities = function (zipCode) {
        setZipCodeApiError(false);
        setZipCodeNotFoundError(false);
        var isValidZipCode = zipCode.match(ZIPCODE_REGEX);
        if (isValidZipCode) {
            setZipCodePending(true);
            addressesApi
                .getPostalList(zipCode)
                .then(function (data) {
                setCities(data);
                var currentCityState = data.find(function (_a) {
                    var city = _a.city, state = _a.state;
                    return normalizeCityState === formatCityState(city, state);
                });
                if (!currentCityState) {
                    setCityState(formatCityState(data[0].city, data[0].state));
                }
            })
                .catch(function (error) {
                var _a, _b, _c;
                pushErrorEvent('address card: edit address', 'inline', error || 'n/a', 'Please provide a valid zip code.');
                if (!isInitialZipCode) {
                    if (((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors[0]) === null || _c === void 0 ? void 0 : _c.errorCode) ===
                        ZIPCODE_NOT_FOUND_ERROR_CODE) {
                        setZipCodeNotFoundError(true);
                        resetCities();
                        return;
                    }
                    setZipCodeApiError(true);
                    resetCities();
                }
            })
                .finally(function () {
                setIsInitialZipCode(false);
                setZipCodePending(false);
            });
        }
    };
    return {
        isZipCodePending: isZipCodePending,
        zipCodeApiError: zipCodeApiError,
        zipCodeNotFoundError: zipCodeNotFoundError,
        cities: cities,
        cityState: cityState,
        loadCities: loadCities,
    };
};
